import { AgGridAngular } from "@ag-grid-community/angular";
import { ColDef, GridOptions } from "@ag-grid-community/core";
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import {
  BulkUploadRunResultItem,
  SupportedBulkUploadEntityModel,
} from "@m19-board/services/bulk-upload/bulk-upload-context.service";
import { BulkUploadGridUtilsService } from "@m19-board/services/bulk-upload/bulk-upload-grid-utils.service";
import {
  BulkUploadRunStatus,
  BulkUploadTypeIconComponent,
} from "../bulk-upload-grid-cells/bulk-upload-type-icon.component";
import { IButtonDirective } from "@front/m19-ui";

@Component({
  selector: "app-bulk-upload-run",
  templateUrl: "./bulk-upload-run.component.html",
  imports: [BulkUploadTypeIconComponent, AgGridAngular, TranslocoDirective, IButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadRunComponent<T extends SupportedBulkUploadEntityModel> {
  private readonly bulkUploadGridUtilsService = inject(BulkUploadGridUtilsService);

  public readonly BulkUploadRunStatus = BulkUploadRunStatus;

  public readonly runResult = input.required<BulkUploadRunResultItem<T>[]>();
  public readonly columnDefs = input.required<ColDef<BulkUploadRunResultItem<T>>[]>();

  public readonly closeImport = output<void>();

  public readonly created = computed(() => {
    return this.runResult().filter((item) => item.status === BulkUploadRunStatus.CREATED);
  });
  public readonly updated = computed(() => {
    return this.runResult().filter((item) => item.status === BulkUploadRunStatus.UPDATED);
  });
  public readonly failed = computed(() => {
    return this.runResult().filter((item) => item.status === BulkUploadRunStatus.FAILED);
  });

  private sortedRunResult = computed(() => {
    return [...this.created(), ...this.updated(), ...this.failed()];
  });

  readonly gridOptions = computed<GridOptions<BulkUploadRunResultItem<T>>>(() =>
    this.bulkUploadGridUtilsService.getGridOptions(this.sortedRunResult(), this.columnDefs()),
  );
}
